/* PostHog (EU, project 301541): laadt pas na analytics-toestemming via Shopify Customer Privacy API. */
(function () {
  var started = false;

  function startPostHog() {
    if (started) return;
    started = true;
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags on onFeatureFlags onSessionId identify setPersonProperties reset get_distinct_id get_session_id get_session_replay_url set_config startSessionRecording stopSessionRecording sessionRecordingStarted opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_sw2Ap6LWkSdrstMNDcUbyyaZ7iP2hqNZmJwwebVzQNvd', {
      api_host: 'https://eu.i.posthog.com',
      ui_host: 'https://eu.posthog.com',
      person_profiles: 'identified_only',
      enable_heatmaps: true,
      session_recording: { maskAllInputs: true }
    });
  }

  function stopPostHog() {
    if (started && window.posthog && window.posthog.opt_out_capturing) {
      window.posthog.opt_out_capturing();
    }
  }

  function check() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) startPostHog();
  }

  document.addEventListener('visitorConsentCollected', function (e) {
    if (e.detail && e.detail.analyticsAllowed) {
      startPostHog();
      if (window.posthog && window.posthog.opt_in_capturing && window.posthog.has_opted_out_capturing && window.posthog.has_opted_out_capturing()) {
        window.posthog.opt_in_capturing();
      }
    } else {
      stopPostHog();
    }
  });

  function load() {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) check();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
